import React from 'react';
import sidebarBg from '../assets/sidebar-bg.png';

const Sidebar = () => {
  return (
    <div className="sidebar">
      <img src={sidebarBg} alt="Sidebar background" />
    </div>
  );
};

export default Sidebar;
